import React from 'react';
import { PortalProvider } from 'react-portal-hook';

export const PageLayout = React.memo(({ children }) => (
  <PortalProvider>{children}</PortalProvider>
));
